import React from "react";
import { Leaf, Sparkles, ShieldCheck, Heart } from "lucide-react";
import { IMAGES } from "../mock";

const PILLARS = [
  {
    icon: Leaf,
    title: "Eco-conscious by choice",
    desc: "We choose plant-based, low-tox products wherever possible — kinder to your home, your family, and the planet.",
  },
  {
    icon: Sparkles,
    title: "Premium, never generic",
    desc: "No supermarket multi-purpose sprays. Only professional-grade products selected for results and finish.",
  },
  {
    icon: ShieldCheck,
    title: "Safe for family & pets",
    desc: "Carefully chosen so your loved ones — including the four-legged ones — can return to a clean home with peace of mind.",
  },
  {
    icon: Heart,
    title: "Tailored on request",
    desc: "Prefer a specific brand or have sensitivities? Tell us and we’ll adjust our kit to suit your home.",
  },
];

const Products = () => {
  return (
    <section id="approach" className="relative py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Image */}
        <div className="relative">
          <div className="absolute -inset-4 bg-sterling/15 rounded-3xl -z-10" />
          <img
            src={IMAGES.products}
            alt="Eco-friendly cleaning products in a styled living room"
            className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
          />
          <div className="absolute -bottom-6 -left-4 lg:-left-8 bg-white rounded-2xl p-5 shadow-xl border border-[#ead8c9] max-w-[260px] hidden md:block">
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#daae9c]">
              <Leaf size={14} className="text-sterling-dark" />
              Considered Products
            </div>
            <div className="font-serif-display text-xl text-ink mt-2 leading-tight">
              Plant-based, low-tox, professional-grade.
            </div>
          </div>
        </div>

        {/* Copy */}
        <div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
            <span className="w-6 h-px bg-sterling-dark" />
            Our Approach to Products
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
            Premium products.{" "}
            <span className="italic text-[#daae9c]">
              Eco-conscious where possible.
            </span>
          </h2>
          <p className="mt-6 text-ink/70 leading-relaxed">
            We don’t reach for generic supermarket sprays. Our kit is built
            around premium, professional-grade products — chosen for their
            results, their finish, and the way they care for your home.
          </p>
          <p className="mt-4 text-ink/70 leading-relaxed">
            Wherever possible, we choose eco-conscious, plant-based formulations
            that are gentler on your family, your pets, and the surfaces we’re
            looking after — without compromising on quality.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  className="p-5 rounded-2xl bg-[#fbf6f0] border border-[#ead8c9] hover:border-sterling-dark transition-colors"
                >
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center border border-[#ead8c9]">
                    <Icon size={18} className="text-sterling-dark" />
                  </div>
                  <div className="font-serif-display text-lg text-ink mt-3">
                    {p.title}
                  </div>
                  <div className="text-sm text-ink/65 mt-1 leading-relaxed">
                    {p.desc}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
